import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import { RewardsCard } from './RewardsCard'
import RewardLogo from '../RewardLogo'
import RewardBullet from './RewardBullet'
import { FormattedMessage } from 'react-intl'

const monthRewardsData = [
  { columnOne: '50 - 99', columnTwo: '25' },
  { columnOne: '100 - 199', columnTwo: '50' },
  { columnOne: '200 - 299', columnTwo: '75' },
  { columnOne: '300 - 399', columnTwo: '100' },
  { columnOne: '400+', columnTwo: '200' },
]

const loyaltyRewardsData = [
  { columnOne: '1 - 3', columnTwo: '10%' },
  { columnOne: '4 - 6', columnTwo: '15%' },
  { columnOne: '7 -24', columnTwo: '20%' },
  { columnOne: '25+', columnTwo: '25%' },
]

// NOTE: The keys used in bulletSectionData should correspond to the translation keys in your i18n files.
const bulletSectionData = [
  { title: 'Join for Free', bullets: ['Enrollment is automatic with your first 50BV monthly subscription.', "No fees, no extra steps--just shop and you're in!"] },
  { title: 'Monthly Subscription Orders', bullets: ['Every 50 BV or more subscription order earns you REWARD points.', 'The more you order, the more you earn!'] },
  { title: 'Loyalty Rewards', bullets: ['Consecutive subscription orders earn REWARD points.'] },
  { title: 'Redeem Your Rewards', bullets: ['Use your REWARD points towards free products', 'No minimum balance required to redeem.'] },
]

const StartPointScaleTwo = () => {
  return (
    <Row style={{ marginTop: '40px' }}>
      <Col lg={12} style={{ borderBottom: '5px solid var(--zls-primary-surface)', marginBottom: '20px' }}>
        <Row>
          <Col lg={3}>
            <h1 style={{ color: 'var(--zls-primary-surface)' }}>
              <RewardLogo pointsRight='32px' fontSize={55} pointsTop='7px' pointFontSize={13} />
            </h1>
          </Col>
          <Col lg={9} style={{ display: 'flex', alignItems: 'center' }}>
            <p style={{ color: 'var(--zls-accent-primary-color)', fontSize: '30px', fontWeight: 400, fontStyle: 'italic', margin: 0 }}>
              <FormattedMessage id='dashboard.ways-to-earn' />
            </p>
          </Col>
        </Row>
      </Col>
      <Col lg={12}>
        <Row>
          <CustomCol sm={12} lg={6}>
            <RewardsCard title={'Monthly'} columnTitle={'Subscription<br/>Level'} bottomLabel={'reward-data.monthly-reward-scale.bottom-label'} rewardsData={monthRewardsData} />
            <RewardsCard title={'Loyalty'} columnTitle={'Consecutive<br/>Months'} bottomLabel={'reward-data.loyalty-reward-scale.bottom-label'} rewardsData={loyaltyRewardsData} />
          </CustomCol>
          <CustomColTwo sm={12} lg={6}>
            {bulletSectionData.map((section, index) => (
              <RewardBullet key={index} title={`reward-data.sections.${index}.title`} bullets={section.bullets.map((_, i) => `reward-data.sections.${index}.messages.${i}`)} />
            ))}
          </CustomColTwo>
        </Row>
      </Col>
    </Row>
  )
}

export default StartPointScaleTwo

const CustomCol = styled(Col)`
  display: flex;
  justify-content: space-around;
  gap: 10px;

  @media (max-width: 1200px) {
    flex-direction: row;
    align-items: center;
    margin-bottom: 40px;
  }

  @media (max-width: 594px) {
    flex-direction: column;
  }
`

const CustomColTwo = styled(Col)`
  @media (max-width: 594px) {
    padding: 30px;
  }
`
